

import {
    Action,
} from 'one-state';

import {
    SET,
    REINIT,
    SETSELECTED,
    SETPATIENTSELECTED,
    RESET,
    ADD,
    CALLERPROVIDER
} from './types';
import { OneSubjectModal } from 'one-card-subject/src/model';
import { Subject } from './Subject';

/**
 * Redux action creator to set the list
 * of upcoming appointments
 * @param subjectstate list of subjects and selected
 * @returns action instance
 */
export const setAction = (subjectstate: OneSubjectModal):
    Action<typeof SET, OneSubjectModal> => ({
        type: SET,
        payload: subjectstate,
    });


/**
 * Redux action creator to add
 * Subject
 * @param subjectstate  selected
 * @returns action instance
 */
export const addAction = (subjectstate: Subject):
    Action<typeof ADD, Subject> => ({
        type: ADD,
        payload: subjectstate ,
    });

/**
 * Redux action creator to set the list
 * of upcoming appointments
 * @param subjectstate  selected
 * @returns action instance
 */
export const setSelectedAction = (subjectstate: Subject):
    Action<typeof SETSELECTED, Subject> => ({
        type: SETSELECTED,
        payload: subjectstate ,
    });    

/**
 * Redux action creator to set the list
 * of upcoming appointments
 * @param subjectstate  selected
 * @returns action instance
 */
 export const setPatientSelectedAction = (subjectstate: Subject):
 Action<typeof SETPATIENTSELECTED, Subject> => ({
     type: SETPATIENTSELECTED,
     payload: subjectstate ,
 });    

/**
 * Re-initialize the state
 * @returns action instance
 */
export const reinitAction = ():
    Action<typeof REINIT> => ({
        type: REINIT,
    });
/**
 * Re-initialize the state
 * @returns action instance
 */
export const resetAction = ():
    Action<typeof RESET> => ({
        type: RESET,
    });

/**
 * Redux action creator if caller is a provider
 * @returns action instance
 */
export const callerProvider = ():
    Action<typeof CALLERPROVIDER> => ({
        type: CALLERPROVIDER,
    });    

/**
 * List of all valid actions
 */
export type Actions =
    ReturnType<typeof setAction> |
    ReturnType<typeof addAction> |
    ReturnType<typeof setSelectedAction> |
    ReturnType<typeof setPatientSelectedAction> |
    ReturnType<typeof reinitAction> |
    ReturnType<typeof callerProvider> |
    ReturnType<typeof resetAction>;


    // export const init = <T>(
    //     list: T,
    //     values: T,
    // ): T => {
    //     const nxt: UpcomingAppointmentsModel = {
    //         values,
    //     };
    //     return nxt;
    // };